
// 库位/库格打印
export function warehouse_location(data){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",500,500,"");
        LODOP.SET_PRINT_PAGESIZE(2,500,300,"");
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        LODOP.ADD_PRINT_IMAGE(0,6,90,90,"<img src='"+data.qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
        var top=80;
        LODOP.ADD_PRINT_TEXT(top,10,110,60,data.name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
        if (data.print_cnt) {
            LODOP.SET_PRINT_COPIES(data.print_cnt);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        }
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
    }
}
// 配件打印
export function material_parts(data){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",500,500,"");
        LODOP.SET_PRINT_PAGESIZE(1,'70mm','40mm',"");
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        LODOP.ADD_PRINT_IMAGE(-5,-5,140,140,"<img src='"+data.qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);

        LODOP.ADD_PRINT_TEXT(15,120,140,22,"编号："+(data.code||data.material_code));
        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
        LODOP.ADD_PRINT_TEXT(37,120,140,22,"名称："+data.name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
        LODOP.ADD_PRINT_TEXT(59,120,140,22,"分类："+data.material_category_name);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
        LODOP.ADD_PRINT_TEXT(81,120,140,110,"型号："+data.model);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",9);

        if (data.print_cnt) {
            LODOP.SET_PRINT_COPIES(data.print_cnt);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        }
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
    }
}
export function material_parts_img(id,data){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",500,500,"");
        LODOP.SET_PRINT_PAGESIZE(1,'70mm','40mm',"");
        LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        var style=`<style>
            table{
                background-color:#fff;
                width:220px;
                table-layout:fixed;
                border-collapse:collapse;
                border:solid 1px #000;
                margin-bottom:10px;
                font-size:10px;
                line-height:1
            }
            table tr td{
                border:solid 1px #000;
                padding:1px 4px
            }
            table tr td:first-child{
                text-align:center;
            }
            table tr td img{
                width:80px;
                height:80px;
                margin-left:-3px
            }
        </style>`;
        var html1=document.getElementById(id).innerHTML;
        LODOP.ADD_PRINT_TABLE(17,15,223,131,style+html1);
        if (data.print_cnt) {
            LODOP.SET_PRINT_COPIES(data.print_cnt);
            LODOP.SET_PRINT_MODE("PRINT_NOCOLLATE",1);
        }
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
    }
}
// 打印出库单
export function outbound_order(data,height,resolve){
    var LODOP = this.$getLodop();
    if (LODOP) {
        LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小
        LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
        LODOP.ADD_PRINT_URL(0,5,800,height,data);
        // LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        LODOP.PRINT();
        if (resolve) {
            resolve();
        }
    }
}

export function material_requisition(data,dataURL,resolve,title='发（领）料单',id='table_table'){
    var LODOP = this.$getLodop();
    console.log(data)
    if (LODOP) {
        var style="<style>table{margin: 5px 0; width: 100%; table-layout:fixed;border-collapse:collapse; border: solid 1px #ebeef5; } table tr td{border: solid 1px #ebeef5; text-align: center; font-size: 14px; padding:5px 5px; } .dayin_html{padding: 10px 0; } .dayin_html .p1{text-align: center; font-size: 30px; font-weight: bold; position: relative; } .dayin_html .p1 .img{width: 120px; position: absolute; top: -45px; left: 0; } .dayin_html .p2{text-align: right; font-size: 16px; padding-right: 20px; line-height: 30px; } .dayin_html .p3{font-size: 16px; padding:5px 0; display: flex; justify-content: space-between; } .dayin_html .p5{font-size: 16px; padding:5px 0; display: flex; align-items: center; justify-content: space-between; } .dayin_html .p5 .img, .dayin_html .p5 img{width: 100px; height: 50px; background-position: center; background-repeat: no-repeat; background-size: contain; object-fit: contain; display: inline-block; vertical-align: middle; } .dayin_html .p5 .img_name{display: inline-block; min-width: 100px; } .dayin_html .p4{font-size: 16px; margin-top: 10px; } .dayin_html .table_table{margin: 5px 0; width: 100%; table-layout:fixed;border-collapse:collapse; border: solid 1px #ebeef5; } .dayin_html .table_table tr td{border: solid 1px #ebeef5; text-align: center; font-size: 14px; padding:5px 5px 0; }</style>";
        LODOP.PRINT_INITA("0cm","0cm",810,1126,""); //画布大小
        LODOP.SET_PRINT_PAGESIZE(1,'210mm','297mm',"A4");  //打印机纸张大小
        var top=30;
        LODOP.SET_PRINT_STYLE("FontSize", 14);
        LODOP.ADD_PRINT_IMAGE(0,0,120,120,"<img src='"+data.outbound_qr_code+"'>");
        LODOP.SET_PRINT_STYLEA(0, "Stretch", 1);
        var top=30;

        LODOP.ADD_PRINT_TEXT(top,5,740,60,title);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",30);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
        LODOP.SET_PRINT_STYLEA(0,"Bold",1);
        top+=50;

        LODOP.ADD_PRINT_TEXT(top,5,740,30,"物资分类:"+data.material_category_name);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
        top+=30;

        LODOP.ADD_PRINT_TEXT(top,5,740/3,30,"存放地点:"+data.info.storage_location);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",1);
        LODOP.ADD_PRINT_TEXT(top,5+740/3,740/3,30,data.info.created);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
        LODOP.ADD_PRINT_TEXT(top,5+740/3*2,740/3,30,"单号:"+data.info.code);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
        top+=30;

        LODOP.ADD_PRINT_TEXT(top,5,740/3,30,"领料工号:"+data.info.department_name);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",1);

        LODOP.ADD_PRINT_TEXT(top,5+740/3,740/3,30,"设备编号:"+data.info.device_code);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

        LODOP.ADD_PRINT_TEXT(top,5+740/3*2,740/3,30,"设备名称:"+data.info.device_name);
        LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
        LODOP.SET_PRINT_STYLEA(0,"FontSize",13);
        top+=30;

        var html1=document.getElementById(id).innerHTML;
        LODOP.ADD_PRINT_TABLE(top,5,740,970,style+html1);
        top+=200;

        LODOP.ADD_PRINT_IMAGE(top,5,740,130,dataURL);
        LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
        LODOP.SET_PRINT_STYLEA(0,"LinkedItem",-1);

        LODOP.PRINT_DESIGN();
        // LODOP.PREVIEW();
        // LODOP.PRINT();
        if (resolve) {
            resolve();
        }
    }
}




// WEBPACK FOOTER //
// ./src/utils/lodop.js